import { createStore, compose } from 'redux';
import {rootReducer} from './rootReducer';
import createMiddleware, { sagaMiddleware } from './middleware'
import adminSagas from './Admin/saga';
import financeQuoteSagas from "./application/saga";
import applicationNotificationsSagas from "./Notifications/saga";
import preferencesSagas from './preferences/saga';
import { indirectDealerSagas } from './dealerService/saga';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(createMiddleware()));
sagaMiddleware.run(adminSagas);
sagaMiddleware.run(financeQuoteSagas);
sagaMiddleware.run(applicationNotificationsSagas);
sagaMiddleware.run(preferencesSagas);
sagaMiddleware.run(indirectDealerSagas);
export default store;